import { isMobile } from 'react-device-detect'

const getResponsiveDrawerWidth = (width: number | string): number | string => (
  isMobile ? "90%" : width 
)

export { getResponsiveDrawerWidth }